export class Rechtshinweis {
  readonly name: string;
  readonly art: string;
  readonly prioritaet: RechtshinweisPriority;
  constructor({
    name,
    art,
    prioritaet,
  }: {
    name: string;
    art: string;
    prioritaet: RechtshinweisPriority;
  }) {
    this.name = name;
    this.art = art;
    this.prioritaet = prioritaet;
  }
}

export type RechtshinweisPriority = 'Info' | 'Warnung' | 'Fatal';
